import { Component, default as React } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Text } from "./components";
import Dashboard from "./pages/Dashboard.js";
import ListAllTraits from "./pages/ListAllTraits.js";
import ListBaseType from "./pages/ListBaseType.js";
import ListMagicItems from "./pages/ListMagicItems.js";
import ListMonsters from "./pages/ListMonsters.js";
import ListPotions from "./pages/ListPotions.js";
import ListSoldiers from "./pages/ListSoldiers.js";
import ListSpells from "./pages/ListSpells.js";
import ListTreasureTables from "./pages/ListTreasureTables.js";
import RollForArmyOprQuest from "./pages/RollForArmyOprQuest.js";
import RollForEvents from "./pages/RollForEvents.js";
import RollForMonster from "./pages/RollForMonster.js";
import * as actions from "./redux/actions/actions.js";
var _ref = null;

class LoginManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comecou: false,
      load: true,
    };
    _ref = this;
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ comecou: true }, (data, error) => {});
    }, 50);
  }

  getRoutesRedirect() {
    let { user = {}, empresa = {} } = this.props;
    let index = 0;
    return [<Route key={index++ + "R"} path="*" element={<Navigate to="/" replace />} />];
  }

  getRoutes() {
    let { user = {} } = this.props;
    let index = 0;
    return [
      <Route key={index++ + ""} exact path="/" element={<RollForMonster />} />,
      <Route key={index++ + ""} exact path="/listmonsters" element={<ListMonsters />} />,
      <Route key={index++ + ""} exact path="/listpotions" element={<ListPotions />} />,
      <Route key={index++ + ""} exact path="/listsoldiers" element={<ListSoldiers />} />,
      <Route key={index++ + ""} exact path="/listmagicitems" element={<ListMagicItems />} />,
      <Route key={index++ + ""} exact path="/listspells" element={<ListSpells />} />,
      <Route key={index++ + ""} exact path="/listbase" element={<ListBaseType />} />,
      <Route key={index++ + ""} exact path="/events" element={<RollForEvents />} />,
      <Route key={index++ + ""} exact path="/listtreasuretables" element={<ListTreasureTables />} />,
      <Route key={index++ + ""} exact path="/armyoprquest" element={<RollForArmyOprQuest />} />,
      <Route key={index++ + ""} exact path="/traits" element={<ListAllTraits />} />,
    ];
  }

  getRotas() {
    let rotas = [...this.getRoutes(), ...this.getRoutesRedirect()];

    return rotas;
  }

  MainRouter() {
    let { user } = this.props;
    return (
      <Routes>
        {this.getRotas()}
        {/* {!this.state.user || !this.state.user.id ? (
            <Redirect to="/login" />
          ) : null} */}
        {/* <Redirect to="/" /> */}
      </Routes>
    );
  }

  render() {
    if (!this.state.comecou) {
      return <Text>Carregando...</Text>;
    }
    return (
      <BrowserRouter basename="/">
        <Dashboard
          MainRouter={() => {
            return this.MainRouter();
          }}
        ></Dashboard>
      </BrowserRouter>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => dispatch(actions.setUser(user)),
  logout: () =>
    actions.logout((data) => {
      dispatch(data);
    }),
});
function mapStateToProps(state) {
  return {
    user: state.Reducer.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginManager);
export function carregaUsuarioLogado(...args) {
  if (_ref) {
    _ref.carregaUsuarioLogado(...args);
  }
}
